export const symbolData = {
  0: {
    name: "blank",
    spine: null,
    symbolPay: "blank",
    texture: "blank",
    value: null,
  },
  1: {
    name: "w1",
    spine: "w1",
    symbolPay: "wild",
    texture: "w1",
    value: null,
  },
  2: {
    name: "h1",
    spine: "h1",
    symbolPay: "hp",
    texture: "h1",
    value: null,
  },
  3: {
    name: "m1",
    spine: "m1",
    symbolPay: "mp",
    texture: "m1",
    value: null,
  },
  4: {
    name: "m2",
    spine: "m2",
    symbolPay: "mp",
    texture: "m2",
    value: null,
  },
  5: {
    name: "l1",
    spine: "l1",
    symbolPay: "lp",
    texture: "l1",
    value: null,
  },
  6: {
    name: "l2",
    spine: "l2",
    symbolPay: "lp",
    texture: "l2",
    value: null,
  },
  7: {
    name: "l3",
    spine: "l3",
    symbolPay: "lp",
    texture: "l3",
    value: null,
  },
  8: {
    name: "l4",
    spine: "l4",
    symbolPay: "lp",
    texture: "l4",
    value: null,
  },
  9: {
    name: "l5",
    spine: "l5",
    symbolPay: "lp",
    texture: "l5",
    value: null,
  },
  10: {
    name: "c",
    spine: null,
    symbolPay: null,
    texture: null,
    value: null,
  },
  11: {
    name: "c1",
    spine: "c",
    symbolPay: "c1",
    texture: "c",
    value: "1",
  },
  12: {
    name: "c2",
    spine: "c",
    symbolPay: "c2",
    texture: "c",
    value: "2",
  },
  13: {
    name: "c3",
    spine: "c",
    symbolPay: "c3",
    texture: "c",
    value: "3",
  },
  14: {
    name: "c5",
    spine: "c",
    symbolPay: "c5",
    texture: "c",
    value: "5",
  },
  15: {
    name: "c7",
    spine: "c",
    symbolPay: "c7",
    texture: "c",
    value: "7",
  },
  16: {
    name: "c10",
    spine: "c",
    symbolPay: "c10",
    texture: "c",
    value: "10",
  },
  17: {
    name: "c12",
    spine: "c",
    symbolPay: "c12",
    texture: "c",
    value: "12",
  },
  18: {
    name: "c15",
    spine: "c",
    symbolPay: "c15",
    texture: "c",
    value: "15",
  },
  19: {
    name: "c25",
    spine: "c",
    symbolPay: "c25",
    texture: "c",
    value: "25",
  },
  20: {
    name: "c50",
    spine: "c",
    symbolPay: "c50",
    texture: "c",
    value: "50",
  },
  21: {
    name: "c100",
    spine: "c",
    symbolPay: "c100",
    texture: "c",
    value: "100",
  },
};

// Wild symbol configuration - calculated from SymbolData once at module load
export const WILD_SYMBOL_ID = (() => {
  const found = Object.entries(symbolData).find(
    ([, data]) => data.name === "w1"
  );
  return found ? parseInt(found[0]) : null;
})();

// Scatter symbol configuration - calculated from SymbolData once at module load
export const SCATTER_SYMBOL_ID = (() => {
  const found = Object.entries(symbolData).find(
    ([, data]) => data.symbolPay === "scatter"
  );
  return found ? parseInt(found[0]) : null;
})();

/**
 * Blank symbol ID - represents empty spaces on the grid
 * Symbol ID 10 (empty c without multiplier) is filtered to this value
 */
export const BLANK_SYMBOL_ID = 0;

// Coin symbol IDs - all symbols with texture === "c", excluding ID 10 (blank coin)
export const COIN_SYMBOL_IDS = (() => {
  return Object.entries(symbolData)
    .filter(([id, data]) => data.texture === "c" && parseInt(id) !== 10)
    .map(([id]) => parseInt(id));
})();

// Probability of generating a coin symbol during random spin/buffer generation (0.035 = 3.5% chance)
export const COIN_GENERATION_PROBABILITY = 0.035;

// Helper function to check if a symbol ID is a coin
export const isCoinSymbol = (symbolId) => {
  if (symbolId === null || symbolId === undefined) return false;
  return COIN_SYMBOL_IDS.includes(symbolId);
};
